import React from "react";
import styles from "./CartPage.module.scss";
import { useProductsStore } from "../../store/productsStore";
import { useNavigate } from "react-router-dom";
import proxyUrl from "../../utils/proxyUrl";

export function getDriveImageUrls(raw) {
  if (!raw) return [];
  return [raw.split(",")[0].trim()];
}

function SmartImage({ urls = [], alt, className }) {
  const [i, setI] = React.useState(0);
  const [useProxy, setUseProxy] = React.useState(false);
  const rawSrc = urls[i] || '';
  const src = !rawSrc ? "/placeholder.jpg" : useProxy ? proxyUrl(rawSrc) : rawSrc;

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => {
        if (!useProxy && rawSrc && !rawSrc.startsWith('/')) {
          setUseProxy(true);
        } else if (i < urls.length - 1) {
          setUseProxy(false);
          setI(i + 1);
        }
      }}
    />
  );
}

function CartPage() {
  const { cart, addToCart, removeFromCart, clearCart } = useProductsStore();
  const navigate = useNavigate();

  const [name, setName] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [comment, setComment] = React.useState("");

  const cartItems = Object.values(cart);

  const parsePrice = (priceStr) => {
    if (!priceStr) return 0;
    const cleaned = priceStr.toString().replace(/\s|₽/g, "");
    const num = parseFloat(cleaned);
    return isNaN(num) ? 0 : num;
  };

  const totalPrice = cartItems.reduce((sum, item) => {
    return sum + parsePrice(item.product["Цена"]) * item.quantity;
  }, 0);

  const handleCheckout = async () => {
    if (cartItems.length === 0) return;
  
    if (!phone.trim()) {
      alert("Пожалуйста, укажите телефон для связи");
      return;
    }
  
    try {
      const itemsPayload = cartItems.map((item) => {
        const product = item.product;
        const price = parsePrice(product["Цена"]);
  
        return {
          name: product["Товар"],
          quantity: item.quantity,
          price,
        };
      });
  
      const resp = await fetch("/api/create-payment.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: totalPrice,
          items: itemsPayload,
          contact: {
            name,
            phone,
            comment,
          },
        }),
      });

      const contentType = resp.headers.get("content-type") || "";
      let data;
  
      if (contentType.includes("application/json")) {
        data = await resp.json();
      } else {
        const text = await resp.text();
        console.error("Не JSON от сервера:", text);
        throw new Error(
          `Сервер вернул не JSON (status ${resp.status} ${resp.statusText})`
        );
      }
  
      if (!resp.ok) {
        console.error("Ошибка создания платежа:", data);
        alert("Не удалось создать платеж. Попробуйте позже.");
        return;
      }
  
      if (!data.confirmationUrl) {
        alert("Не удалось получить ссылку на оплату.");
        return;
      }
  
      clearCart();
      window.location.href = data.confirmationUrl;
    } catch (e) {
      console.error("Ошибка оформления заказа/оплаты:", e);
      alert("Ошибка при оформлении заказа. Попробуйте позже.");
    }
  };
  return (
    <div className={styles.cartPage}>
      <h1 className={styles.title}>Корзина</h1>

      {cartItems.length === 0 ? (
        <p className={styles.emptyCart}>Корзина пока пуста</p>
      ) : (
        <>
          <div className={styles.cartList}>
            {cartItems.map((item, idx) => {
              const product = item.product;
              const urls = getDriveImageUrls(product["Фото"]);
              const price = parsePrice(product["Цена"]);
              return (
                <div key={idx} className={styles.cartItem}>
                  <SmartImage
                    urls={urls}
                    alt={product["Товар"]}
                    className={styles.cartItemImg}
                  />
                  <div className={styles.cartItemInfo}>
                    <p className={styles.cartItemName}>{product["Товар"]}</p>
                    <p className={styles.cartItemPrice}>
                      {price.toLocaleString()} ₽ × {item.quantity} ={" "}
                      <b>{(price * item.quantity).toLocaleString()} ₽</b>
                    </p>
                    <div className={styles.counter}>
                      <button onClick={() => removeFromCart(product)}>-</button>
                      <span>{item.quantity}</span>
                      <button onClick={() => addToCart(product)}>+</button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className={styles.cartSummary}>
            <p className={styles.total}>
              Итого: <b>{totalPrice.toLocaleString()} ₽</b>
            </p>

            <div className={styles.contactForm}>
              <input
                type="text"
                placeholder="Ваше имя"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                type="tel"
                placeholder="Телефон для связи"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
              <textarea
                placeholder="Комментарий к заказу"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
            </div>

            <button
              className={styles.checkoutButton}
              onClick={handleCheckout}
              disabled={cartItems.length === 0 || !phone.trim()}
            >
              Оплатить
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default CartPage;
